module.exports = __webpack_public_path__ + "static/media/island.a08e357f.png";